import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "text-3xl font-medium" }
const _hoisted_3 = { class: "mt-2 text-gray-800" }
const _hoisted_4 = { class: "mt-6 border border-gray-400 rounded" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Parent/Carer", -1)
const _hoisted_7 = { class: "mt-2 text-gray-800" }
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-red-500" }
const _hoisted_14 = { class: "flex justify-between px-4 py-2" }
const _hoisted_15 = { class: "flex items-center space-x-4" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "px-4 pb-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " The primary parent/carer will be asked to create an account and consent to their child’s data being stored. The primary/parent carer will be able to add feedback on their child’s progress. Additional parents/carers will be able to view progress. ", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "mt-6" }
const _hoisted_21 = { class: "flex flex-wrap gap-4 py-6" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import DefaultButton from "@/components/DefaultButton.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";
import { userHasRole } from "@/utils/roles";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewStudent',
  setup(__props) {

const route = useRoute();
const globalStore = useGlobalStore();
const { user, userIsAdmin } = storeToRefs(useUserStore());
const isSaving = ref(false);

const club_id = Number(route.params.id);

const errors = ref([] as { valid: boolean; message: string }[]);

const student = ref({
  club_id: club_id,
  first_name: "",
  last_name: "",
  middle_name: "",
  survey_permission: false,
  parents: [
    {
      first_name: "",
      last_name: "",
      email: "",
      is_primary: true,
    },
  ],
});

function addParent() {
  student.value.parents.push({
    email: "",
    first_name: "",
    last_name: "",
    is_primary: false,
  });
}

function removeParent(index: number) {
  if (index === 0) return;
  student.value.parents.splice(index, 1);
}

function togglePrimaryParent(index: number) {
  student.value.parents.map(parent => (parent.is_primary = false));
  student.value.parents[index].is_primary = !student.value.parents[index].is_primary;
}

async function saveStudent() {
  /** Check first and last name are maximum 3 letters */
  if (student.value.first_name.length > 3) {
    globalStore.toast("ERROR", "First name must be maximum 3 letters");
    return;
  }

  if (student.value.middle_name.length > 3) {
    globalStore.toast("ERROR", "Middle name must be maximum 3 letters");
    return;
  }

  if (student.value.last_name.length > 3) {
    globalStore.toast("ERROR", "Last name must be maximum 3 letters");
    return;
  }

  /** Do parent email check first */
  const results = (
    await api.students.checkParentEmailsByFacilitator(
      String(club_id),
      student.value.parents.map(p => p.email)
    )
  ).data;

  errors.value = results.map(r => ({ valid: r.valid, message: r.message }));

  if (results.find(r => !r.valid)) {
    globalStore.toast("ERROR", "One or more parent emails are already in use");
    return;
  }

  try {
    isSaving.value = true;
    const response = await api.clubs.createClubStudent(club_id, student.value);

    if (response.data) {
      globalStore.toast("SUCCESS", "Club Participant created");
      return (window.location.href = `/dashboard/clubs/${club_id}/participants/${response.data.student.id}`);
    }
  } catch (e) {
    console.log("ERROR", e);
    isSaving.value = false;
  }
}

if (!userIsAdmin.value && !userHasRole(user.value.roles, ["certified-facilitator", "advanced-facilitator", "advanced-facilitator-trainee", "facilitator-organisation"])) {
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('add-new-club-member')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(saveStudent, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("child-details")), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("child-details-helptext")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ListRowItem, {
            title: _ctx.$t('first-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((student.value.first_name) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                maxlength: "3",
                required: ""
              }, null, 512), [
                [_vModelText, student.value.first_name]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('middle-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((student.value.middle_name) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                maxlength: "3"
              }, null, 512), [
                [_vModelText, student.value.middle_name]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('family-name-initial')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((student.value.last_name) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                maxlength: "3",
                required: ""
              }, null, 512), [
                [_vModelText, student.value.last_name]
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("parent-carer-helptext")), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(student.value.parents, (parent, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6 border border-gray-400 rounded",
              key: index
            }, [
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('first-name')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((student.value.parents[index].first_name) = $event),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_9), [
                    [_vModelText, student.value.parents[index].first_name]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('last-name')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "name",
                    "onUpdate:modelValue": ($event: any) => ((student.value.parents[index].last_name) = $event),
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_10), [
                    [_vModelText, student.value.parents[index].last_name]
                  ])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('email')}`
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "email",
                    "onUpdate:modelValue": ($event: any) => ((student.value.parents[index].email) = $event),
                    placeholder: "Email",
                    class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                    required: ""
                  }, null, 8, _hoisted_11), [
                    [_vModelText, student.value.parents[index].email]
                  ]),
                  (Object.keys(errors.value).length && !errors.value[index].valid)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _createElementVNode("small", _hoisted_13, _toDisplayString(errors.value[index].message), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(ToggleCheckbox, {
                    value: student.value.parents[index].is_primary,
                    onToggle: ($event: any) => (togglePrimaryParent(index))
                  }, null, 8, ["value", "onToggle"]),
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("make-primary-parent-carer")), 1)
                ]),
                _createElementVNode("div", null, [
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-link",
                        type: "button",
                        onClick: ($event: any) => (removeParent(index))
                      }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ]),
              (parent.is_primary)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(DefaultButton, {
            type: "primary",
            onClick: addParent
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("add-another")) + " " + _toDisplayString(_ctx.$t("parent-carer")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(RouterButton, {
          type: "primary",
          to: { name: 'Brick_Club', params: { id: _unref(club_id) } }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(DefaultButton, {
          id: "review",
          type: "primary",
          "is-form-submit": true,
          loading: isSaving.value,
          disabled: isSaving.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("save-club-member")), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ], 40, _hoisted_1)
  ], 64))
}
}

})